<template>
  <div>
    <popup-edit-pouring-category ref="popupEditPouringCategory" />
    <div class="flex justify-between p-3">
      <p>
        Pouring categories are used to create pricing groups for products. This
        can be used when defining sales products.
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupEditPouringCategory.show()"
          type="relief"
          color="primary"
          disabled="true"
          class="mr-3"
          >Add pouring category</vs-button
        >
      </div>
    </div>
    <vs-row class="mt-4">
      <vs-col
        class="rolecard p-3"
        v-for="pc in pouringCategories"
        :key="pc.pouringCategoryId.id"
      >
        <vs-card>
          <div slot="header">
            <vs-row vs-justify="space-between">
              <h6>{{ pc.name }}</h6>
              <div>
                <feather-icon
                  disabled="true"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="editLocation(pc)"
                />
                <feather-icon
                  disabled="true"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click="confirmDelete(pc)"
                />
              </div>
            </vs-row>
          </div>
          <div>
            <vs-row class="mt-4">
              <vs-col vs-w="4">ID</vs-col>
              <vs-col vs-w="8"
                ><i>{{ pc.pouringCategoryId.id }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Name</vs-col>
              <vs-col vs-w="8"
                ><i>{{ pc.name }}</i></vs-col
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- Save & Remove Button -->
    <vs-row>
      <vs-button id="save-button" disabled class="mt-2">Save Changes</vs-button>
    </vs-row>
  </div>
</template>

<script>
import popupEditPouringCategory from "./PopupEditPouringCategory.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    popupEditPouringCategory,
  },
  data() {
    return {
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.pouringCategoryId.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this pouring category?",
        accept: this.remove,
      });
    },
    async remove() {
      // this.$vs.loading();
      // await this.$store.dispatch("pos/venues/deleteLocation", {
      //   venueId: this.venue.id,
      //   locationId: this.removeId,
      // });
      // this.$vs.loading.close();
    },
    async editLocation(location) {
      this.$refs.popupEditLocation.show(location);
    },
  },
  computed: {
    ...mapGetters({
      pouringCategories: "pos/countrySettings/pouringCategories",
    }),
  },

  async mounted() {},
};
</script>


<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>